<template>
  <vx-card heading-size="h1" title="Notifications">
    <div id="todo-app">
      <transition-group
        class="todo-list mb-5"
        name="list-enter-up"
        tag="ul"
        appear
        v-if="notifications.length > 0"
      >
        <li
          class="cursor-pointer todo_todo-item"
          v-for="notification in notifications"
          :key="notification.id"
        >
          <div
            role="button"
            tabindex="0"
            @click="getOnclickNotification(notification.onclick_route)"
            @keydown.enter.prevent="getOnclickNotification(notification.onclick_route)"
            @keydown.space.prevent="getOnclickNotification(notification.onclick_route)"
            class="px-4 py-4 list-item-component"
          >
            <div class="vx-row">
              <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
                <div class="flex items-center">
                  <h6 class="todo-title">{{ notification.data.title }}</h6>
                </div>
              </div>

              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <small class="mt-1 mr-4 whitespace-no-wrap">{{
                  elapsedTime(notification.created_at)
                }}</small>
                <feather-icon
                  icon="CheckCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="[
                    { 'text-success stroke-current': notification.is_read },
                    'w-5',
                    'h-5 mr-4',
                  ]"
                  @click.stop="markNotificationRead(notification.id)"
                />
                <feather-icon
                  v-if="!notification.isTrashed"
                  icon="TrashIcon"
                  class="cursor-pointer"
                  svgClasses="w-5 h-5"
                  @click.stop="deleteNotification(notification.id)"
                />
              </div>
            </div>
            <div class="vx-row" v-if="notification.data.text">
              <div class="vx-col w-full">
                <p class="mt-2 truncate">{{ notification.data.text }}</p>
              </div>
            </div>
          </div>
        </li>
      </transition-group>
      <p v-else>No notifications found</p>

      <div class="overflow-hidden py-5">
        <button
          class="btn btn-secondary danger btn-size-medium float-left mr-5 includedIcon"
          @click="deleteAllNotifications"
          v-if="notifications.length > 0"
        >
          <trash-icon />
          Delete All Notifications
        </button>
        <button
          class="btn btn-secondary btn-size-medium float-left mr-5 includedIcon"
          @click="markAllNotificationsRead"
          v-if="notifications.length > 0"
        >
          <check-circle-icon />
          Mark All Notifications as Read
        </button>
        <button
          class="btn btn-primary btn-size-medium float-left mr-5 includedIcon"
          @click="downloadNotifications"
          v-if="notifications.length > 0"
        >
          <save-icon />
          Download Notifications as CSV
        </button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import router from '@/router/router';
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import { TrashIcon, CheckCircleIcon, SaveIcon } from 'vue-feather-icons';

export default {
  components: {
    TrashIcon,
    CheckCircleIcon,
    SaveIcon,
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    notifications() {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        return store.getters['authStudent/notifications'];
      } else if (login_type == 'teacher') {
        return store.getters['authTeacher/notifications'];
      }
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  methods: {
    elapsedTime(startTime) {
      const x = new Date(startTime);
      const now = new Date();
      let timeDiff = now - x;
      timeDiff /= 1000;

      const seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      const minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      const hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      const days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      const years = timeDiff;

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`;
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`;
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`;
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`;
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now');
      }

      return 'Just Now';
    },
    getOnclickNotification(onclick_route) {
      if (onclick_route !== null) {
        router.push(onclick_route);
      }
    },
    markNotificationRead(nID) {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        store.dispatch('authStudent/markNotificationRead', nID);
      } else if (login_type == 'teacher') {
        store.dispatch('authTeacher/markNotificationRead', nID);
      }
    },
    deleteNotification(nID) {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        store.dispatch('authStudent/deleteNotification', nID);
      } else if (login_type == 'teacher') {
        store.dispatch('authTeacher/deleteNotification', nID);
      }
    },
    deleteAllNotifications() {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        store.dispatch('authStudent/deleteNotifications');
      } else if (login_type == 'teacher') {
        store.dispatch('authTeacher/deleteNotifications');
      }
    },
    markAllNotificationsRead() {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'student') {
        store.dispatch('authStudent/markLastNotificationsRead', this.notifications.length);
      } else if (login_type == 'teacher') {
        store.dispatch('authTeacher/markLastNotificationsRead', this.notifications.length);
      }
    },
    downloadNotifications() {
      theApi.methods.makeCall(false, 'notifications/download', 'post').then(
        (csvData) => {
          if (csvData.status == 'OK') {
            let csvContent = 'data:text/csv;charset=utf-8,';
            csvContent += [...csvData.data.map((item) => Object.values(item).join(';'))]
              .join('\n')
              .replace(/(^\[)|(\]$)/gm, '');

            const data = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', data);
            link.setAttribute('download', 'export.csv');
            link.click();
          }
        },
        () => {},
      );
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/vuexy/apps/todo.scss';
</style>
